import $ from "jquery";

// edited by Eprincev, добавил eventKey для снятия обработчиков
/*!
 * jQuery Double Tap Plugin.
 *
 * Copyright (c) 2010 Raul Sanchez (http://www.appcropolis.com)
 *
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */

// Determine if we on iPhone or iPad
let isiOS = false;
let agent = navigator.userAgent.toLowerCase();
if ( agent.indexOf("iphone") >= 0 || agent.indexOf("ipad") >= 0 ) {
    isiOS = true;
}

$.fn.doubletap = function(options) {
    options = $.extend({
        eventKey: "",
        delay: 500
    }, options);

    let eventKey = options.eventKey;


    let onDoubleTapCallback = options.onDoubleTap;


    let onTapCallback = options.onTap;


    let delay = options.delay;

    let eventName; let action;
    eventName = isiOS == true ? "touchend" : "click"; // jshint ignore: line
    eventName += eventKey;

    $(this).bind(eventName, function(event) {
        let now = new Date().getTime();
        let lastTouch = $(this).data("lastTouch") || now + 1 /** the first time this will make delta a negative number */;
        let delta = now - lastTouch;
        clearTimeout(action);
        if ( delta < 500 && delta > 0 ) {
            if ( onDoubleTapCallback != null && typeof onDoubleTapCallback == "function" ) {
                onDoubleTapCallback(event);
            }
        } else {
            $(this).data("lastTouch", now);
            action = setTimeout(function(evt) {
                if ( onTapCallback != null && typeof onTapCallback == "function" ) {
                    onTapCallback(evt);
                }
                clearTimeout(action); // clear the timeout
            }, delay, [event]);
        }
        $(this).data("lastTouch", now);
    });
};
